document.addEventListener('DOMContentLoaded', () => {
  function _doInit(swiperObj) {
    const swiperElem = typeof swiperObj.el === 'object' ? swiperObj.el : document.querySelector(swiperObj.el)
    const cardWrapper = swiperElem.querySelector(
      'nova-product-card',
    )
    const imgWrapper = cardWrapper?.shadowRoot?.querySelector('.product-card__image') || null
    if (imgWrapper) {
      const h = imgWrapper.getBoundingClientRect().height
      swiperElem.style.setProperty('--block-height', `${h}px`)
    }
  }

  function _doCarousel(productCarousel) {
    const sectionId = productCarousel.dataset.sectionId
    const mobilePerPage = productCarousel.dataset.mobilePerPage || 1.5
    const tabletPerPage = productCarousel.dataset.tabletPerPage || 2.5
    const sdesktopPerPage = productCarousel.dataset.sdesktopPerPage || 3.5
    const desktopPerPage = productCarousel.dataset.desktopPerPage || 3.9
    const ldesktopPerPage = productCarousel.dataset.ldesktopPerPage || 4.9
    const noLeftOffset = productCarousel.hasAttribute('no-left-offset')

    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: mobilePerPage,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.product-carousel--icon-next',
        prevEl: '.product-carousel--icon-previous',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      a11y: {
        enabled: false,
      },
      breakpoints: {
        768: {
          slidesPerView: tabletPerPage,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: sdesktopPerPage,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: 45,
        },
        1200: {
          slidesPerView: desktopPerPage,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: noLeftOffset ? 0 : 45,
          spaceBetween: 20,
        },
        1600: {
          slidesPerView: ldesktopPerPage,
          slidesOffsetAfter: 45,
          slidesOffsetBefore: noLeftOffset ? 0 : 45,
          spaceBetween: 20,
        },
      }
    }

    const swiperObj = new Swiper(`.js-product-carousel-swiper-${sectionId}`, option)
    swiperObj.on('init', _doInit(swiperObj))
    swiperObj.on('resize', (swiper) => {
      _doInit(swiper)
    })
    swiperObj.init()
  }

  function buildProductCarousel() {
    const $productCarousels = document.querySelectorAll('.js-product-carousel-swiper')
    for (const $productCarousel of $productCarousels) {
      _doCarousel($productCarousel)
    }
  }

  buildProductCarousel()

  document.addEventListener('nova:product-carousel-loaded', buildProductCarousel)

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', buildProductCarousel)
  }
})
